module.exports = __webpack_public_path__ + "img/48.639c6936.jpg";